import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import { TFunction } from "i18next"

export const TIPO_DOC_LABEL = (t: TFunction): Record<number, string> => ({
  [TIPO_DOCUMENTO_ENUM.FACTURA]: t("flujoAprobaciones.items.cardMap.invoice"),
  [TIPO_DOCUMENTO_ENUM.DNI]: t("flujoAprobaciones.items.cardMap.dni"),
  [TIPO_DOCUMENTO_ENUM.PAGARE]: t(
    "flujoAprobaciones.items.cardMap.promissoryNote"
  ),
  [TIPO_DOCUMENTO_ENUM.ALBARAN]: t("flujoAprobaciones.items.cardMap.delivery"),
  [TIPO_DOCUMENTO_ENUM.PEDIDO]: t("flujoAprobaciones.items.cardMap.notes"),
  [TIPO_DOCUMENTO_ENUM.PRESUPUESTO]: t(
    "flujoAprobaciones.items.cardMap.quotation"
  ),
  [TIPO_DOCUMENTO_ENUM.FACTURA_RECURRENTE]: t(
    "flujoAprobaciones.items.cardMap.recurrentInvoice"
  ),
})
